var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "w-100 d-flex flex-column align-items-center" },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-column align-items-center gap-20" },
        [
          _c("div", { staticClass: "position-relative" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "64",
                  height: "78",
                  viewBox: "0 0 64 78",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M63.2001 27.066C63.1594 26.7077 63.081 26.3548 62.9661 26.013V25.662C62.7785 25.261 62.5284 24.8924 62.2251 24.57L38.8251 1.17C38.5027 0.866643 38.1341 0.616516 37.7331 0.429C37.6166 0.412464 37.4985 0.412464 37.3821 0.429C36.9859 0.201791 36.5483 0.0559424 36.0951 0H12.5C9.39702 0 6.42108 1.23268 4.2269 3.42685C2.03272 5.62103 0.800049 8.59697 0.800049 11.7V66.3C0.800049 69.403 2.03272 72.379 4.2269 74.5732C6.42108 76.7673 9.39702 78 12.5 78H51.5001C54.6031 78 57.579 76.7673 59.7732 74.5732C61.9674 72.379 63.2001 69.403 63.2001 66.3V27.3V27.066ZM39.8001 13.299L49.9011 23.4H43.7001C42.6657 23.4 41.6737 22.9891 40.9423 22.2577C40.2109 21.5263 39.8001 20.5343 39.8001 19.5V13.299ZM55.4001 66.3C55.4001 67.3343 54.9892 68.3263 54.2578 69.0577C53.5264 69.7891 52.5344 70.2 51.5001 70.2H12.5C11.4657 70.2 10.4737 69.7891 9.74233 69.0577C9.01094 68.3263 8.60005 67.3343 8.60005 66.3V11.7C8.60005 10.6657 9.01094 9.67368 9.74233 8.94228C10.4737 8.21089 11.4657 7.8 12.5 7.8H32.0001V19.5C32.0001 22.603 33.2327 25.579 35.4269 27.7732C37.6211 29.9673 40.597 31.2 43.7001 31.2H55.4001V66.3ZM40.9311 40.131L28.1001 53.001L23.0691 47.931C22.3347 47.1966 21.3386 46.784 20.3001 46.784C19.2615 46.784 18.2654 47.1966 17.531 47.931C16.7967 48.6654 16.3841 49.6614 16.3841 50.7C16.3841 51.7386 16.7967 52.7346 17.531 53.469L25.3311 61.269C25.6936 61.6345 26.125 61.9247 26.6002 62.1227C27.0755 62.3207 27.5852 62.4226 28.1001 62.4226C28.6149 62.4226 29.1246 62.3207 29.5999 62.1227C30.0752 61.9247 30.5065 61.6345 30.8691 61.269L46.4691 45.669C47.2034 44.9346 47.616 43.9386 47.616 42.9C47.616 41.8614 47.2034 40.8654 46.4691 40.131C45.7347 39.3966 44.7386 38.984 43.7001 38.984C42.6615 38.984 41.6654 39.3966 40.9311 40.131Z",
                    fill: "#E8EAED",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "text-center vue-uploadbox-drop-text",
              class: _vm.darkText,
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("trans")("File added! Start task or add more files")
                  ) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex gap-10 flex-wrap justify-content-center" },
            [
              _c("div", { staticClass: "btn-group adjust-button" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-light font-size-125 font-weight-bold text-wrap vue-uploadbox-file-button position-static d-flex align-items-center justify-content-center gap-10",
                    class: { "rounded-bottom-0": _vm.showDropdown },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.openFileUploadDialog($event)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "18",
                          viewBox: "0 0 16 18",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M14.4033 8.6V5L10.8033 1H2.40327C2.1911 1 1.98762 1.08429 1.83759 1.23431C1.68756 1.38434 1.60327 1.58783 1.60327 1.8V16.2C1.60327 16.4122 1.68756 16.6157 1.83759 16.7657C1.98762 16.9157 2.1911 17 2.40327 17H7.20327M11.6033 11V16.6M8.80327 13.8H14.4033",
                            stroke: "#2E2E2E",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M10.4033 1V5H14.4033",
                            stroke: "#2E2E2E",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("trans")("Add more files")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-light dropdown-toggle dropdown-toggle-split border-left",
                    class: { "rounded-bottom-0": _vm.showDropdown },
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.$emit("toggle-drop-down")
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-chevron-down" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "dropdown-menu m-0 w-100 rounded-top-0 user-select-none",
                    class: { show: _vm.showDropdown },
                    attrs: { id: "dropdownMenu" },
                  },
                  [
                    _c("div", { staticClass: "dropdown-item px-0" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                          attrs: {
                            id: "DeviceUploadButton",
                            title: _vm._f("trans")("Upload From Device"),
                            tag: "span",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.openFileUploadDialog($event)
                            },
                          },
                        },
                        [
                          _vm._m(0),
                          _vm._v(
                            _vm._s(_vm._f("trans")("From Device")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-item px-0" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                          attrs: {
                            id: "dropboxButton",
                            title: _vm._f("trans")(
                              "Choose one or more files from Dropbox"
                            ),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.$emit("open-drop-box-dialog")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "px-75" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 43 40",
                                  version: "1.1",
                                  width: "15px",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                                    fill: "#007EE5",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(
                            _vm._s(_vm._f("trans")("From Dropbox")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-item px-0",
                        class: { "opacity-65": _vm.disableGdriveButton },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.$emit("open-g-drive-dialog")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                            attrs: {
                              id: "gdriveButton",
                              title: _vm._f("trans")(
                                "Choose one or more files from Google Drive"
                              ),
                            },
                          },
                          [
                            _c("span", { staticClass: "px-75" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "15px",
                                    viewBox: "0 0 87.3 78",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                                      fill: "#0066da",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                                      fill: "#00ac47",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                                      fill: "#ea4335",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                                      fill: "#00832d",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                                      fill: "#2684fc",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                                      fill: "#ffba00",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                            _vm._v(
                              _vm._s(_vm._f("trans")("From Google Drive")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _vm.hasClientId
                      ? _c(
                          "div",
                          {
                            staticClass: "dropdown-item px-0",
                            class: { "opacity-65": _vm.disableOnedriveButton },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.$emit("open-one-drive-dialog")
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                                attrs: {
                                  id: "onedriveButton",
                                  title: _vm._f("trans")(
                                    "Choose one or more files from OneDrive"
                                  ),
                                },
                              },
                              [
                                _c("span", { staticClass: "px-75" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        "data-v-b2efc490": "",
                                        width: "15px",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 5.5 32 20.5",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            "data-v-b2efc490": "",
                                            id: "STYLE_COLOR",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              "data-v-b2efc490": "",
                                              d: "M12.20245,11.19292l.00031-.0011,6.71765,4.02379,4.00293-1.68451.00018.00068A6.4768,6.4768,0,0,1,25.5,13c.14764,0,.29358.0067.43878.01639a10.00075,10.00075,0,0,0-18.041-3.01381C7.932,10.00215,7.9657,10,8,10A7.96073,7.96073,0,0,1,12.20245,11.19292Z",
                                              fill: "#0364b8",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              "data-v-b2efc490": "",
                                              d: "M12.20276,11.19182l-.00031.0011A7.96073,7.96073,0,0,0,8,10c-.0343,0-.06805.00215-.10223.00258A7.99676,7.99676,0,0,0,1.43732,22.57277l5.924-2.49292,2.63342-1.10819,5.86353-2.46746,3.06213-1.28859Z",
                                              fill: "#0078d4",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              "data-v-b2efc490": "",
                                              d: "M25.93878,13.01639C25.79358,13.0067,25.64764,13,25.5,13a6.4768,6.4768,0,0,0-2.57648.53178l-.00018-.00068-4.00293,1.68451,1.16077.69528L23.88611,18.19l1.66009.99438,5.67633,3.40007a6.5002,6.5002,0,0,0-5.28375-9.56805Z",
                                              fill: "#1490df",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              "data-v-b2efc490": "",
                                              d: "M25.5462,19.18437,23.88611,18.19l-3.80493-2.2791-1.16077-.69528L15.85828,16.5042,9.99475,18.97166,7.36133,20.07985l-5.924,2.49292A7.98889,7.98889,0,0,0,8,26H25.5a6.49837,6.49837,0,0,0,5.72253-3.41556Z",
                                              fill: "#28a8ea",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(
                                  _vm._s(_vm._f("trans")("From OneDrive")) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-item px-0" },
                      [
                        _c(
                          "RouterLink",
                          {
                            staticClass:
                              "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                            attrs: {
                              id: "externalUrlButton",
                              to: { name: "remote-url" },
                              title: _vm._f("trans")(
                                "Enter the link of a file you want to use"
                              ),
                              tag: "span",
                            },
                          },
                          [
                            _c("span", { staticClass: "px-75" }, [
                              _c("i", {
                                staticClass: "fa fa-link",
                                staticStyle: { width: "15px" },
                              }),
                            ]),
                            _vm._v(
                              _vm._s(_vm._f("trans")("From URL")) +
                                "\n                        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-item px-0" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center",
                          attrs: {
                            id: "copyFromClipboard",
                            title: _vm._f("trans")("Copy From Clipboard"),
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.$emit("copy-from-clipboard")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "px-75" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "14",
                                  height: "17",
                                  viewBox: "0 0 14 17",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M4.8 13.3C4.36 13.3 3.98347 13.1435 3.6704 12.8304C3.35733 12.5173 3.20053 12.1405 3.2 11.7V2.1C3.2 1.66 3.3568 1.28347 3.6704 0.9704C3.984 0.657333 4.36053 0.500533 4.8 0.5H12C12.44 0.5 12.8168 0.6568 13.1304 0.9704C13.444 1.284 13.6005 1.66053 13.6 2.1V11.7C13.6 12.14 13.4435 12.5168 13.1304 12.8304C12.8173 13.144 12.4405 13.3005 12 13.3H4.8ZM4.8 11.7H12V2.1H4.8V11.7ZM1.6 16.5C1.16 16.5 0.783467 16.3435 0.4704 16.0304C0.157333 15.7173 0.000533333 15.3405 0 14.9V4.5C0 4.27333 0.0768001 4.08347 0.2304 3.9304C0.384 3.77733 0.573867 3.70053 0.8 3.7C1.02667 3.7 1.2168 3.7768 1.3704 3.9304C1.524 4.084 1.60053 4.27387 1.6 4.5V14.9H9.6C9.82666 14.9 10.0168 14.9768 10.1704 15.1304C10.324 15.284 10.4005 15.4739 10.4 15.7C10.4 15.9267 10.3232 16.1168 10.1696 16.2704C10.016 16.424 9.82613 16.5005 9.6 16.5H1.6Z",
                                    fill: "#2E2E2E",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(
                            _vm._s(_vm._f("trans")("From Clipboard")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.showSettingsBtn ? _c("settings-button") : _vm._e(),
              _vm._v(" "),
              _vm.showSubmitBtn
                ? _c(
                    "div",
                    {
                      staticClass:
                        "btn-group uploader-submit-button adjust-button",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-lg submit-btn white-space-nowrap mb-0 d-flex align-items-center justify-content-center gap-10 w-100 uploader-submit-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("startClicked")
                            },
                          },
                        },
                        [
                          _c(
                            "strong",
                            {
                              staticClass:
                                "text-uppercase convert_to uploader-submit-button",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm._f("trans")("Start", {}, "general")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "fa fa-arrow-right lh-inherit uploader-submit-button",
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "px-75" }, [
      _c("i", {
        staticClass: "fa fa-folder-open",
        staticStyle: { width: "15px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }